import axios from 'axios';
import utils from '@/utils/utils.js';
import { VueCookieNext } from 'vue-cookie-next';

const instance = axios.create({
  baseURL: '/api',
});
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['responseType'] = 'json';
instance.defaults.headers.get['Content-Type'] = 'application/json';

instance.interceptors.request.use(
  async (config) => {
    if (VueCookieNext.getCookie('accessToken')) {
      const jwt = utils.parseJwt(VueCookieNext.getCookie('accessToken'));
      if (jwt.exp < new Date().getTime() / 1000) {
        await authRefresh();
      }
    }
    config.headers['Authorization'] =
      VueCookieNext.getCookie('accessToken') || '';

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (
      !error ||
      (error && !error.response) ||
      (error && typeof error.response !== 'object')
    ) {
      VueCookieNext.removeCookie('accessToken');
      error.callback = () => {
        location.href = `/login/?redirect=${encodeURIComponent(
          location.href.replace(location.origin, '')
        )}`;
      };
      error.systemMessage = 'ログインが必要です。';
    } else if (error.response.status == '401') {
      error.callback = () => {
        location.href = `/login/?redirect=${encodeURIComponent(
          location.href.replace(location.origin, '')
        )}`;
      };
      error.systemMessage = 'ログインが必要です。';
    } else if (error.response.status == '404') {
      error.systemMessage = 'お探しのページは見つかりませんでした';
    } else if (
      error.response.status == '500' ||
      error.response.status == '400'
    ) {
      error.systemMessage = error.response.statusText;
    } else {
      VueCookieNext.removeCookie('accessToken');
      error.callback = () => {
        location.href = `/login/?redirect=${encodeURIComponent(
          location.href.replace(location.origin, '')
        )}`;
      };
      error.systemMessage = 'ログインが必要です。';
    }

    return Promise.reject(error);
  }
);

async function authRefresh() {
  const config = {
    method: 'post',
    url: '/api/auth/refresh',
    headers: {
      Authorization: VueCookieNext.getCookie('accessToken'),
    },
    data: '',
  };
  await axios(config)
    .then((response) => {
      const accessToken =
        response.data.token_type + ' ' + response.data.access_token;

      VueCookieNext.setCookie('accessToken', accessToken, {
        expire: response.data.refresh_ttl,
      });
    })
    .catch(() => {
      VueCookieNext.removeCookie('accessToken');
    });
}

export default instance;
